import React from 'react';
require('./RowHandler.scss');
// 同步行按钮组件
class RowHandler extends React.Component {
	constructor(props) {
		super(props);
        this.onRowTouchTap = this.onRowTouchTap.bind(this);
	}

    onRowTouchTap(evt) {
        evt.preventDefault();
		evt.stopPropagation();
		if(this.props.onRowTouchTap) {
			this.props.onRowTouchTap(this.props.id,this.props.index);
		}
    }


	render() {
		return (
            <div className='row-Artboard' onTouchTap={this.onRowTouchTap} style={this.props.style}></div>
		);
	}
}

export default RowHandler;


// WEBPACK FOOTER //
// ./src/components/TableColumns/RowHandler/RowHandler.js